import { add } from "date-fns";

export default class Discount {
  name: string;
  startTime: number;
  endTime: number;
  createdAt: number;
  id: string;
  discount?: number | null;
  flatDiscount?: number | null;
  periodic: boolean;
  weekdays: Array<number>;
  testId: string;
  labId: string;
  categoryId: string;
  runsForever: boolean;

  getStatus: Function = (): string => {
    let nowTime = new Date().getTime();
    if (this.endTime < nowTime) {
      return "expired";
    } else if (nowTime < this.startTime) {
      return "upcoming";
    } else {
      if (this.weekdays.includes(new Date().getDay())) {
        return "active";
      } else {
        return "inactive";
      }
    }
  };

  constructor({ discountData }: { discountData?: any }) {
    let createdAt = new Date().getTime();
    let startTime = new Date().getTime();
    let endTime = add(new Date(), { days: 1 }).getTime();
    let id = "";
    let discount = null;
    let flatDiscount = null;
    let periodic = false;
    let weekdays = [];
    let testId = "";
    let categoryId = "";
    let labId = "";
    let name = "";
    let runsForever = false;

    if (discountData) {
      ({
        createdAt,
        startTime,
        endTime,
        id,
        discount,
        flatDiscount,
        periodic,
        weekdays,
        testId,
        categoryId,
        labId,
        name,
        runsForever,
      } = discountData);
    }
    this.startTime = startTime;
    this.endTime = endTime;
    this.createdAt = createdAt;
    this.id = id;
    this.discount = discount;
    this.flatDiscount = flatDiscount;
    this.periodic = periodic;
    this.weekdays = weekdays;
    this.testId = testId;
    this.categoryId = categoryId;
    this.labId = labId;
    this.name = name;
    this.runsForever = runsForever;
  }
}

export function getDiscountValues(discount: Discount): any {
  let values: any = {
    startTime: discount.startTime,
    endTime: discount.endTime,
    createdAt: discount.createdAt,
    id: discount.id,
    periodic: discount.periodic,
    weekdays: discount.weekdays,
    testId: discount.testId,
    categoryId: discount.categoryId,
    labId: discount.labId,
    name: discount.name,
    flatDiscount: discount.flatDiscount,
    discount: discount.discount,
    runsForever: discount.runsForever,
  };
  return values;
}
